import { render, staticRenderFns } from "./OrderMethod.vue?vue&type=template&id=440e1634&scoped=true"
import script from "./OrderMethod.vue?vue&type=script&lang=js"
export * from "./OrderMethod.vue?vue&type=script&lang=js"
import style0 from "./OrderMethod.vue?vue&type=style&index=0&id=440e1634&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440e1634",
  null
  
)

export default component.exports